function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var NotificationTemplate = require('./notification.template');
var TweetTemplate = require('./tweet.template');
function returnMessage(tx) {
  if (tx && typeof tx.returnMessage === 'function') {
    return tx.returnMessage();
  }
  return tx && tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
}
var Notification = /*#__PURE__*/function () {
  function Notification(app, mod) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Notification);
    this.app = app;
    this.mod = mod;
    this.container = '';
    this.tx = null;
    this.signature = '';
    this.tweet_signature = '';
    this.type = '';
    this.actor_publicKey = '';
    this.actor_name = '';
    this.actor_avatar = '/saito/img/dreamscape.png';
    this.text = '';
    this.count = 1;
    this.created_at = Date.now();
    this.time = '';
    this.unread = true;
    if (data && data.tx) {
      this.tx = data.tx;
      this.parseFromTransaction();
      return;
    }
    this.parseFromData(data);
  }
  return _createClass(Notification, [{
    key: "parseFromTransaction",
    value: function parseFromTransaction() {
      if (!this.tx) {
        return;
      }
      var txmsg = returnMessage(this.tx);
      var data = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
      this.signature = this.tx.signature != null ? String(this.tx.signature) : '';
      this.created_at = Number(this.tx.timestamp) || Date.now();
      this.actor_publicKey = this.extractPublicKey();
      this.applyActor(this.actor_publicKey);
      this.time = this.app.browser.formatRelativeTime(this.created_at);
      if (txmsg.request === 'like tweet') {
        this.type = 'like';
        this.tweet_signature = data.signature != null ? String(data.signature) : '';
      } else if (txmsg.request === 'retweet') {
        var hasCommentary = Boolean(String(data.text || '').trim()) || Array.isArray(data.images) && data.images.length > 0;
        this.type = hasCommentary ? 'quote' : 'retweet';
        this.tweet_signature = data.signature != null ? String(data.signature) : '';
      } else if (txmsg.request === 'create tweet') {
        this.type = data.parent_id ? 'reply' : 'tweet';
        this.tweet_signature = this.signature;
      } else {
        this.type = data.type != null ? String(data.type) : '';
        this.tweet_signature = data.tweet_signature != null ? String(data.tweet_signature) : data.signature != null ? String(data.signature) : '';
      }
      this.text = this.buildActionText();
    }
  }, {
    key: "parseFromData",
    value: function parseFromData(data) {
      if (!data || _typeof(data) !== 'object') {
        return;
      }
      this.signature = data.signature != null ? String(data.signature) : '';
      this.tweet_signature = data.tweet_signature != null ? String(data.tweet_signature) : '';
      this.type = data.type != null ? String(data.type) : '';
      this.actor_publicKey = data.actor_publicKey != null ? String(data.actor_publicKey) : '';
      this.actor_name = data.actor_name != null ? String(data.actor_name) : '';
      this.actor_avatar = data.actor_avatar != null ? String(data.actor_avatar) : '/saito/img/dreamscape.png';
      this.text = data.text != null ? String(data.text) : '';
      this.count = Number(data.count) > 0 ? Number(data.count) : 1;
      this.created_at = Number(data.created_at) || Date.now();
      this.time = data.time != null ? String(data.time) : this.app.browser.formatRelativeTime(this.created_at);
      this.unread = data.unread !== false;
      if (!this.text) {
        this.text = this.buildActionText();
      }
      if (!this.actor_name && this.actor_publicKey) {
        this.applyActor(this.actor_publicKey);
      }
    }
  }, {
    key: "extractPublicKey",
    value: function extractPublicKey() {
      if (this.tx && this.tx.from && this.tx.from[0] && this.tx.from[0].publicKey) {
        return String(this.tx.from[0].publicKey);
      }
      return '';
    }
  }, {
    key: "applyActor",
    value: function applyActor(publicKey) {
      if (!publicKey) {
        this.actor_name = 'anon';
        this.actor_avatar = '/saito/img/dreamscape.png';
        return;
      }
      this.actor_name = this.app.keychain.returnUsername(publicKey) || publicKey.slice(0, 8);
      this.actor_avatar = this.app.keychain.returnIdenticon(publicKey) || '/saito/img/dreamscape.png';
    }
  }, {
    key: "buildActionText",
    value: function buildActionText() {
      switch (this.type) {
        case 'like':
          if (this.count > 1) {
            return "liked your post (".concat(this.count, ")");
          }
          return 'liked your post';
        case 'reply':
          return 'posted a new reply';
        case 'quote':
          return 'quoted your post';
        case 'retweet':
          return 'reposted your post';
        case 'tweet':
          return 'posted a new tweet';
        default:
          return 'sent you a notification';
      }
    }
  }, {
    key: "refreshActionText",
    value: function refreshActionText() {
      this.text = this.buildActionText();
    }
  }, {
    key: "getReferencedTweet",
    value: function getReferencedTweet() {
      return this.mod.getTweet(this.tweet_signature);
    }
  }, {
    key: "renderHTML",
    value: function renderHTML() {
      var tweet = this.getReferencedTweet();
      if (!tweet) {
        return '';
      }
      var tweetHtml = TweetTemplate(tweet, 'tweet slot', {
        presentation: 'timeline',
        hideControls: true
      });
      return NotificationTemplate(this, tweetHtml);
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      var html = this.renderHTML();
      if (!html) {
        return;
      }
      this.app.browser.addElementToSelector(html, this.container);
    }
  }], [{
    key: "fromTransaction",
    value: function fromTransaction(app, mod, tx) {
      return new Notification(app, mod, {
        tx: tx
      });
    }
  }]);
}();
module.exports = Notification;